import { Box, Stack, Text, Tiles, Heading } from 'braid-design-system';
import React from 'react';

import { encodeSvg } from 'src/shared/helpers';

import branding2 from '../images/Devices.svg';
import branding1 from '../images/SearchNew.svg';
import branding3 from '../images/SuccessHifive.svg';

import { sellingPointWidth } from '../style/style.css';

const data = [
  {
    title: 'Be seen by more candidates',
    desc: 'Ads with branding stand out in job search results and job ad previews.',
    img: encodeSvg(branding1),
  },
  {
    title: 'Get exposure across devices',
    desc: 'Be visible on mobile, desktop and tablets with branding optimised for all devices.',
    img: encodeSvg(branding2),
  },
  {
    title: 'Extend your reach',
    desc: 'Feature in our targeted emails that reach 83 million candidates a month.',
    img: encodeSvg(branding3),
  },
];

const IconSellingPoints = () => (
  <Tiles space="large" columns={[1, 3]}>
    {data.map((item, i) => (
      <Box key={i}>
        <Stack space="medium" align="center">
          <Box
            style={{
              backgroundImage: item.img,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              width: '128px',
              height: '128px',
            }}
          />
          <Stack space="gutter">
            <Heading level="4" align="center">
              {item.title}
            </Heading>
            <Box key={i} className={sellingPointWidth}>
              <Text align="center" tone="secondary">
                {item.desc}
              </Text>
            </Box>
          </Stack>
        </Stack>
      </Box>
    ))}
  </Tiles>
);

export default IconSellingPoints;
